import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { ActivatedRoute, Router} from '@angular/router';

@Injectable()
export class MobileModeService {
  constructor(
    public storageService: StorageService,
    private router: Router
    ) { }
  public async isMobileMode(userToken) {
    if(userToken){
      let userDetail = this.parseJwt(userToken);
      let SetUserToken = {
        "token" : userToken,
        "user" : userDetail
      }
      this.storageService.setStorage('user', JSON.stringify(SetUserToken));
      this.storageService.setStorage('mobileMode', true);
      if(userToken && userDetail.auth && userDetail.email){
        return true;
      }
    }
    return true;
  }

  /**
    * 
    * @param token   userParentToken
    */
   parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

}
